/* Veithdia · Probador virtual de lentes
 * Cámara o foto → MediaPipe Face Landmarker (corre en el navegador) → PNG frontal del marco sobre los ojos.
 * La imagen nunca sale del dispositivo.
 */
(function () {
  'use strict';

  var MP_VER = '0.10.14';
  var MP_URL = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@' + MP_VER + '/vision_bundle.mjs';
  var WASM_URL = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@' + MP_VER + '/wasm';
  var MODEL_URL =
    'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task';

  var WIDTH_FACTOR = 1.68; // ancho del marco respecto a la distancia entre las comisuras externas de los ojos
  var DEFAULT_ANCHOR = 0.42; // altura de la línea de los ojos dentro del PNG (0 = arriba, 1 = abajo)
  var SMOOTH = 0.5;

  var root = document.querySelector('[data-vt-tryon]');
  if (!root || root.dataset.vtReady) return;
  root.dataset.vtReady = '1';

  var trigger = root.querySelector('.vt-tryon-trigger');
  var items = [];
  try {
    var raw = JSON.parse(root.querySelector('[data-vt-tryon-items]').textContent);
    var seen = {};
    raw.forEach(function (it) {
      if (!it || !it.src) return;
      var key = it.src.split('?')[0];
      if (seen[key]) return;
      seen[key] = true;
      items.push(it);
    });
  } catch (e) {
    items = [];
  }

  if (!items.length && /[?&]probador=demo\b/.test(location.search) && root.dataset.demoSrc) {
    items.push({ id: null, opt: null, name: 'Modelo de prueba', src: root.dataset.demoSrc, thumb: root.dataset.demoSrc, anchor: 0.48 });
  }
  if (!items.length || !trigger) return;
  trigger.hidden = false;

  /* ---------- Estado ---------- */
  var modal, stage, canvas, ctx, video, msg, msgText, hint, colorsWrap, fileInput, camBtn;
  var landmarker = null;
  var mode = 'IDLE'; // CAMERA | PHOTO
  var stream = null;
  var raf = 0;
  var lastVideoTime = -1;
  var lastFaceAt = 0;
  var photo = null;
  var photoLandmarks = null;
  var current = 0;
  var userScale = 1;
  var smooth = null;
  var landmarks = null;
  var imgCache = {};

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function loadImg(src) {
    if (imgCache[src]) return imgCache[src];
    var p = new Promise(function (resolve, reject) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        resolve(im);
      };
      im.onerror = reject;
      im.src = src;
    });
    imgCache[src] = p;
    return p;
  }

  var glassesImg = null;
  function setItem(i, fromUser) {
    current = i;
    var it = items[i];
    glassesImg = null;
    loadImg(it.src).then(function (im) {
      if (items[current] === it) glassesImg = im;
      if (mode === 'PHOTO') draw();
    });
    if (colorsWrap) {
      Array.prototype.forEach.call(colorsWrap.children, function (b, j) {
        b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
      });
    }
    if (fromUser && it.opt) selectVariantOnPage(it.opt);
  }

  function selectVariantOnPage(value) {
    var inputs = document.querySelectorAll('variant-selects input[type="radio"]');
    for (var k = 0; k < inputs.length; k++) {
      if (inputs[k].value === value) {
        if (!inputs[k].checked) inputs[k].click();
        return;
      }
    }
  }

  function selectedVariantId() {
    var f = document.querySelector('product-info form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="id"]');
    return f ? Number(f.value) : null;
  }

  /* ---------- Modal ---------- */
  function buildModal() {
    modal = el('div', 'vt-tryon');
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'VtTryonTitle');
    modal.innerHTML =
      '<div class="vt-tryon__panel">' +
      '  <div class="vt-tryon__head">' +
      '    <h2 class="vt-tryon__title" id="VtTryonTitle">Pruébatelos</h2>' +
      '    <button type="button" class="vt-tryon__close" aria-label="Cerrar probador">&times;</button>' +
      '  </div>' +
      '  <div class="vt-tryon__stage">' +
      '    <video class="vt-tryon__video" playsinline muted autoplay></video>' +
      '    <canvas></canvas>' +
      '    <div class="vt-tryon__msg"><div class="vt-tryon__spinner"></div><p class="vt-tryon__msgtext">Cargando el probador…</p></div>' +
      '    <div class="vt-tryon__hint" hidden>Mira de frente a la cámara</div>' +
      '  </div>' +
      '  <div class="vt-tryon__controls">' +
      '    <div class="vt-tryon__colors" role="group" aria-label="Colores disponibles"></div>' +
      '    <div class="vt-tryon__row">' +
      '      <div class="vt-tryon__size"><span>Tamaño</span>' +
      '        <button type="button" data-size="-1" aria-label="Achicar">−</button>' +
      '        <button type="button" data-size="1" aria-label="Agrandar">+</button></div>' +
      '      <div class="vt-tryon__actions">' +
      '        <button type="button" class="vt-tryon__btn" data-cam hidden>Cámara</button>' +
      '        <label class="vt-tryon__btn">Subir foto<input type="file" accept="image/*"></label>' +
      '        <button type="button" class="vt-tryon__btn vt-tryon__btn--solid" data-snap>Guardar</button>' +
      '      </div>' +
      '    </div>' +
      '    <p class="vt-tryon__privacy">Todo ocurre en tu dispositivo: no guardamos ni enviamos tu imagen. La vista es referencial; revisa las medidas en la ficha técnica.</p>' +
      '  </div>' +
      '</div>';
    document.body.appendChild(modal);
    var pname = (root.dataset.productName || '').split(/\s+[–—-]\s+/)[0];
    if (pname) modal.querySelector('.vt-tryon__title').textContent = 'Pruébate ' + pname;

    stage = modal.querySelector('.vt-tryon__stage');
    canvas = stage.querySelector('canvas');
    ctx = canvas.getContext('2d');
    video = stage.querySelector('video');
    msg = stage.querySelector('.vt-tryon__msg');
    msgText = stage.querySelector('.vt-tryon__msgtext');
    hint = stage.querySelector('.vt-tryon__hint');
    colorsWrap = modal.querySelector('.vt-tryon__colors');
    fileInput = modal.querySelector('input[type="file"]');
    camBtn = modal.querySelector('[data-cam]');

    items.forEach(function (it, i) {
      var b = el('button', 'vt-tryon__color');
      b.type = 'button';
      b.title = it.opt || it.name || '';
      b.setAttribute('aria-label', it.opt || it.name || 'Color ' + (i + 1));
      b.innerHTML = '<img alt="" src="' + (it.thumb || it.src) + '">';
      b.addEventListener('click', function () {
        setItem(i, true);
      });
      colorsWrap.appendChild(b);
    });
    if (items.length < 2) colorsWrap.hidden = true;

    modal.querySelector('.vt-tryon__close').addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
    modal.querySelectorAll('[data-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        userScale = Math.max(0.75, Math.min(1.35, userScale + Number(b.dataset.size) * 0.05));
        if (mode === 'PHOTO') draw();
      });
    });
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (f) usePhoto(f);
      fileInput.value = '';
    });
    camBtn.addEventListener('click', startCamera);
    modal.querySelector('[data-snap]').addEventListener('click', snapshot);
    window.addEventListener('resize', function () {
      if (!modal.hidden) {
        sizeCanvas();
        if (mode === 'PHOTO') draw();
      }
    });
  }

  function showMsg(text, spinner) {
    msg.hidden = false;
    msgText.textContent = text;
    msg.querySelector('.vt-tryon__spinner').style.display = spinner ? '' : 'none';
  }
  function hideMsg() {
    msg.hidden = true;
  }

  function sizeCanvas() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = stage.clientWidth;
    var h = stage.clientHeight;
    if (canvas.width !== Math.round(w * dpr) || canvas.height !== Math.round(h * dpr)) {
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
    }
  }

  function open() {
    if (!modal) buildModal();
    var vid = selectedVariantId();
    var idx = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === vid) idx = i;
    }
    setItem(idx, false);
    userScale = 1;
    smooth = null;
    modal.hidden = false;
    document.body.classList.add('vt-tryon-open');
    sizeCanvas();
    modal.querySelector('.vt-tryon__close').focus();
    showMsg('Cargando el probador…', true);
    getLandmarker()
      .then(function () {
        if (mode !== 'PHOTO') startCamera();
      })
      .catch(function () {
        showMsg('No pudimos cargar el probador en este navegador. Prueba con Chrome o Safari actualizados.', false);
      });
  }

  function close() {
    stopCamera();
    cancelAnimationFrame(raf);
    mode = 'IDLE';
    photo = null;
    photoLandmarks = null;
    modal.hidden = true;
    document.body.classList.remove('vt-tryon-open');
    trigger.focus();
  }

  /* ---------- MediaPipe ---------- */
  // Se carga con un <script type="module"> porque el minificador de Shopify reescribe import() dinámico.
  function loadVision() {
    if (window.__vtVision) return Promise.resolve(window.__vtVision);
    return new Promise(function (resolve, reject) {
      var done = false;
      window.addEventListener(
        'vt-vision-ready',
        function () {
          done = true;
          resolve(window.__vtVision);
        },
        { once: true }
      );
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent =
        'import * as v from "' + MP_URL + '"; window.__vtVision = v; window.dispatchEvent(new Event("vt-vision-ready"));';
      document.head.appendChild(s);
      setTimeout(function () {
        if (!done) reject(new Error('vision timeout'));
      }, 30000);
    });
  }

  var lmPromise = null;
  function getLandmarker() {
    if (lmPromise) return lmPromise;
    lmPromise = loadVision().then(function (vision) {
      return vision.FilesetResolver.forVisionTasks(WASM_URL).then(function (fileset) {
        function create(delegate) {
          return vision.FaceLandmarker.createFromOptions(fileset, {
            baseOptions: { modelAssetPath: MODEL_URL, delegate: delegate },
            runningMode: 'VIDEO',
            numFaces: 1,
          });
        }
        return create('GPU')
          .catch(function () {
            return create('CPU');
          })
          .then(function (lm) {
            landmarker = lm;
            landmarker._vtMode = 'VIDEO';
            return lm;
          });
      });
    });
    lmPromise.catch(function () {
      lmPromise = null;
    });
    return lmPromise;
  }

  function setRunningMode(m) {
    if (landmarker && landmarker._vtMode !== m) {
      landmarker.setOptions({ runningMode: m });
      landmarker._vtMode = m;
    }
  }

  /* ---------- Cámara ---------- */
  function startCamera() {
    photo = null;
    photoLandmarks = null;
    camBtn.hidden = true;
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      showMsg('Tu navegador no permite usar la cámara aquí. Sube una foto tuya de frente.', false);
      return;
    }
    showMsg('Permite el acceso a la cámara para probarte los lentes.', true);
    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: 'user', width: { ideal: 720 }, height: { ideal: 960 } }, audio: false })
      .then(function (s) {
        stream = s;
        video.srcObject = s;
        return video.play();
      })
      .then(function () {
        mode = 'CAMERA';
        setRunningMode('VIDEO');
        hideMsg();
        lastFaceAt = performance.now();
        smooth = null;
        loop();
      })
      .catch(function () {
        stopCamera();
        showMsg('No pudimos acceder a la cámara. Revisa los permisos del navegador o sube una foto tuya de frente.', false);
      });
  }

  function stopCamera() {
    if (stream) {
      stream.getTracks().forEach(function (t) {
        t.stop();
      });
      stream = null;
    }
    if (video) video.srcObject = null;
  }

  function loop() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function tick() {
      if (mode !== 'CAMERA') return;
      if (video.readyState >= 2 && video.currentTime !== lastVideoTime) {
        lastVideoTime = video.currentTime;
        try {
          var res = landmarker.detectForVideo(video, performance.now());
          landmarks = res.faceLandmarks && res.faceLandmarks[0] ? res.faceLandmarks[0] : null;
        } catch (e) {
          landmarks = null;
        }
      }
      if (landmarks) lastFaceAt = performance.now();
      hint.hidden = performance.now() - lastFaceAt < 900;
      draw();
      raf = requestAnimationFrame(tick);
    });
  }

  /* ---------- Foto ---------- */
  function usePhoto(file) {
    stopCamera();
    cancelAnimationFrame(raf);
    mode = 'PHOTO';
    camBtn.hidden = false;
    hint.hidden = true;
    showMsg('Analizando tu foto…', true);
    var url = URL.createObjectURL(file);
    var im = new Image();
    im.onload = function () {
      getLandmarker()
        .then(function () {
          setRunningMode('IMAGE');
          var res = landmarker.detect(im);
          photo = im;
          photoLandmarks = res.faceLandmarks && res.faceLandmarks[0] ? res.faceLandmarks[0] : null;
          smooth = null;
          if (!photoLandmarks) {
            showMsg('No encontramos un rostro en la foto. Prueba con una foto de frente, con buena luz y sin lentes.', false);
            draw();
            msg.hidden = false;
          } else {
            hideMsg();
            draw();
          }
        })
        .catch(function () {
          showMsg('No pudimos analizar la foto.', false);
        });
    };
    im.onerror = function () {
      showMsg('No pudimos abrir esa imagen.', false);
    };
    im.src = url;
  }

  /* ---------- Dibujo ---------- */
  function coverMap(srcW, srcH, W, H, mirror, focus) {
    var s = Math.max(W / srcW, H / srcH);
    var ox, oy, dw, dh;
    if (focus) {
      // acerca la foto al rostro: el rostro ocupa ~58% del ancho visible
      s = Math.max(s, (W * 0.58) / (focus.w * srcW));
      dw = srcW * s;
      dh = srcH * s;
      ox = W / 2 - focus.cx * dw;
      oy = H * 0.42 - focus.cy * dh;
      ox = Math.min(0, Math.max(W - dw, ox));
      oy = Math.min(0, Math.max(H - dh, oy));
    } else {
      dw = srcW * s;
      dh = srcH * s;
      ox = (W - dw) / 2;
      oy = (H - dh) / 2;
    }
    return {
      draw: function (source) {
        if (mirror) {
          ctx.save();
          ctx.translate(W, 0);
          ctx.scale(-1, 1);
          ctx.drawImage(source, ox, oy, dw, dh);
          ctx.restore();
        } else {
          ctx.drawImage(source, ox, oy, dw, dh);
        }
      },
      pt: function (p) {
        var x = ox + p.x * dw;
        return { x: mirror ? W - x : x, y: oy + p.y * dh };
      },
    };
  }

  function mid(a, b) {
    return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
  }

  function draw() {
    sizeCanvas();
    var W = canvas.width;
    var H = canvas.height;
    ctx.clearRect(0, 0, W, H);
    var source, sw, sh, lms, mirror;
    if (mode === 'CAMERA') {
      source = video;
      sw = video.videoWidth;
      sh = video.videoHeight;
      lms = landmarks;
      mirror = true;
    } else if (mode === 'PHOTO' && photo) {
      source = photo;
      sw = photo.naturalWidth;
      sh = photo.naturalHeight;
      lms = photoLandmarks;
      mirror = false;
    } else {
      return;
    }
    if (!sw || !sh) return;
    var focus = null;
    if (mode === 'PHOTO' && lms) {
      var minX = 1, maxX = 0, minY = 1, maxY = 0;
      for (var q = 0; q < lms.length; q++) {
        if (lms[q].x < minX) minX = lms[q].x;
        if (lms[q].x > maxX) maxX = lms[q].x;
        if (lms[q].y < minY) minY = lms[q].y;
        if (lms[q].y > maxY) maxY = lms[q].y;
      }
      focus = { cx: (minX + maxX) / 2, cy: (minY + maxY) / 2, w: maxX - minX };
    }
    var map = coverMap(sw, sh, W, H, mirror, focus);
    map.draw(source);
    if (!lms || !glassesImg) return;

    var a = map.pt(lms[33]);
    var b = map.pt(lms[263]);
    var eA = mid(map.pt(lms[33]), map.pt(lms[133]));
    var eB = mid(map.pt(lms[263]), map.pt(lms[362]));
    if (a.x > b.x) {
      var t = a;
      a = b;
      b = t;
      t = eA;
      eA = eB;
      eB = t;
    }
    var eyeDist = Math.hypot(b.x - a.x, b.y - a.y);
    var center = mid(eA, eB);
    var angle = Math.atan2(b.y - a.y, b.x - a.x);
    var nose = map.pt(lms[1]);
    var outer = mid(a, b);
    var yaw = (nose.x - outer.x) / (eyeDist || 1);

    var target = { x: center.x, y: center.y, d: eyeDist, a: angle, yaw: yaw };
    if (mode === 'CAMERA' && smooth) {
      smooth = {
        x: smooth.x + (target.x - smooth.x) * SMOOTH,
        y: smooth.y + (target.y - smooth.y) * SMOOTH,
        d: smooth.d + (target.d - smooth.d) * SMOOTH,
        a: smooth.a + (target.a - smooth.a) * SMOOTH,
        yaw: smooth.yaw + (target.yaw - smooth.yaw) * SMOOTH,
      };
    } else {
      smooth = target;
    }

    var it = items[current] || {};
    var anchor = typeof it.anchor === 'number' ? it.anchor : DEFAULT_ANCHOR;
    var gw = smooth.d * WIDTH_FACTOR * userScale;
    var gh = gw * (glassesImg.naturalHeight / glassesImg.naturalWidth);
    var squash = 1 - Math.min(0.28, Math.abs(smooth.yaw) * 0.55);

    ctx.save();
    ctx.translate(smooth.x, smooth.y);
    ctx.rotate(smooth.a);
    ctx.scale(squash, 1);
    ctx.shadowColor = 'rgba(0,0,0,0.25)';
    ctx.shadowBlur = gw * 0.02;
    ctx.shadowOffsetY = gw * 0.01;
    ctx.drawImage(glassesImg, -gw / 2 + smooth.yaw * gw * 0.08, -gh * anchor, gw, gh);
    ctx.restore();
  }

  /* ---------- Guardar foto ---------- */
  function snapshot() {
    if (mode === 'IDLE') return;
    try {
      canvas.toBlob(
        function (blob) {
          if (!blob) return;
          var name = 'veithdia-probador.jpg';
          var file = typeof File === 'function' ? new File([blob], name, { type: 'image/jpeg' }) : null;
          if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator.share({ files: [file], title: 'Mis lentes Veithdia' }).catch(function () {});
          } else {
            var a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = name;
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
              URL.revokeObjectURL(a.href);
              a.remove();
            }, 1000);
          }
        },
        'image/jpeg',
        0.92
      );
    } catch (e) {
      /* lienzo protegido: no se puede exportar */
    }
  }

  trigger.addEventListener('click', open);
  // precarga liviana cuando el botón se acerca a la pantalla
  if ('IntersectionObserver' in window) {
    var pre = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) {
        pre.disconnect();
        items.slice(0, 3).forEach(function (it) {
          loadImg(it.src);
        });
      }
    });
    pre.observe(trigger);
  }
})();
